import { styled } from '@aibi-ui/core';
import { Input } from 'antd';
import IconChatDelete from '@gainer-ui/ai-bi-chat/assets/icons/chat-delete.svg';
import IconChatSearch from '@gainer-ui/ai-bi-chat/assets/icons/chat-search.svg';
import { Dispatch, SetStateAction } from 'react';

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 38px;

  .ant-input-affix-wrapper {
    background: #f7f8fc;
    border-radius: 6px;
    height: 38px;
    .ant-input-prefix {
      svg {
        fill: none;
        width: 16px;
        height: 16px;
      }
    }
  }

  .ant-input {
    background: #f7f8fc;
    &::placeholder {
      font-size: 12px;
      color: #bbbbbb;
    }
  }

  .search-clear-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    min-width: 38px;
    height: 38px;
    background: #f7f8fc;
    border-radius: 6px;
    border: 1px solid #d2d2d2;
    cursor: pointer;
    color: #666;
    transition: all 0.1s ease;
    &:hover {
      color: #333;
    }
    svg {
      fill: none;
      width: 16px;
      height: 16px;
    }
  }
`;

const SearchBar = ({
  searchValue,
  setSearchValue,
  setShowDelete,
  onSearch,
}: {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setShowDelete: Dispatch<SetStateAction<boolean>>;
  onSearch: (value: string) => void;
}) => (
  <SearchContainer>
    <Input
      placeholder="搜索历史记录"
      value={searchValue}
      onChange={e => setSearchValue(e.target.value)}
      prefix={<IconChatSearch viewBox="0 0 16 16" />}
      suffix={<></>}
      allowClear
      onPressEnter={() => onSearch(searchValue)}
    />
    <div className="search-clear-icon" onClick={() => setShowDelete(true)}>
      <IconChatDelete viewBox="0 0 16 16" />
    </div>
  </SearchContainer>
);

export default SearchBar;
